<div class="popup-container">
  <div>
    <div class="modal-header">
      <span class="modal-title header-13">{{ data.title }}</span>
      <button
        type="button"
        class="accello-icon-btn"
        (mousedown)="isActive = true"
        (mouseup)="isActive = false"
        (mouseleave)="isActive = false"
        (click)="activeModal.dismiss('Cross click')"
      >
        <img
          [src]="
            isActive
              ? 'assets/images/virtusa-icons/close-dark.svg'
              : 'assets/images/virtusa-icons/close.svg'
          "
        />
      </button>
    </div>
    <div *ngIf="isDataLoaded" class="popup-body">
      <div class="row warning-msg">
        <div class="w-auto">
          <span>{{ warningMessage }}</span>
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-4 px-0">
          <div class="col-10 mb-3 mx-2">
            <div class="accello-general-text6 mb-3">Test Plan Name</div>
            <input
              class="name-field form-control"
              type="text"
              [(ngModel)]="planName"
              placeholder="Test Plan Name"
            />
          </div>

          <div class="row mx-2 px-0 accello-general-text6 mb-3">
            Folder Hierarchy
          </div>
          <div class="row mx-0">
            <div class="col-10 px-0">
              <div class="row mx-2 search-tree">
                <input
                  type="text"
                  class="search-input form-control"
                  [(ngModel)]="treeSearch"
                  (keyup)="modifyTree()"
                  placeholder="Search Test Suite or Test Case"
                />
              </div>
              <div class="row mx-2 tree-container">
                <app-tree-view
                  class="w-100"
                  [nodes]="treeSearch != '' ? searchResults : treeData"
                  [selectedNode]="selectedItem"
                  (menuItemSelected)="selectCase($event)"
                ></app-tree-view>
              </div>
            </div>
            <div class="col-2 px-0">
              <div
                class="d-flex flex-column justify-content-center align-items-center row h-100"
              >
                <button
                  class="arrow-btn mb-2"
                  (click)="moveSelected('add')"
                  [disabled]="!selectedItem.id"
                >
                  <img
                    src="assets/images/virtusa-icons/arrow-right.svg"
                    alt="arrow-icon"
                    class="button-icon"
                  />
                </button>

                <button
                  class="arrow-btn"
                  (click)="moveSelected('remove')"
                  [disabled]="selectedRows.length === 0"
                >
                  <img
                    src="assets/images/virtusa-icons/arrow-left.svg"
                    alt="arrow-icon"
                    class="button-icon"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8 px-0 d-flex flex-column">
          <div class="d-flex mx-0 align-items-center">
            <div class="flex-grow-1 accello-general-text6">
              Selected Test cases
            </div>
            <div class="mx-2 globle-select">

              <app-menu-dropdown
                [selectedValue]="agentValue"
                [placeholderText]="''"
                [data]="agentSections"
                (onSelect)="updateGlobalAgent($event)">
              </app-menu-dropdown>


            </div>
            <div class="globle-select">
              <app-dropdown-with-sections
                [config]="browsersConfig"
                [fields]="browsersSections"
                [selectedValue]="browserValue"
                (onSelect)="updateGlobalBrowser($event)"
              ></app-dropdown-with-sections>
            </div>
          </div>
          <div class="flex-grow-1">
            <div
              id="create-edit-plan"
              class="row mx-0 table-container px-0"
              cdkDropList
              cdkDropListConnectedTo="tree-node-drag"
              (cdkDropListDropped)="drop($event)"
            >
              <app-zorro-table
                tableId="add-edit-tcp"
                class="w-100 px-0"
                [columns]="columns"
                [data]="dataSource"
                (handleActions)="handleActionsInTable($event)"
                (onRowSelect)="handleSelect($event)"
              ></app-zorro-table>
            </div>
          </div>

          <div class="col"></div>
        </div>
      </div>
      <div class="d-flex my-3 justify-content-end">
        <button
          type="button"
          class="btn-accello-secondary mx-2"
          (click)="closePopup()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn-accello-primary-light"
          [class]="
            !dataSource.length || planName.trim() == '' ? 'not-allowed' : ''
          "
          [disabled]="!dataSource.length || planName.trim() == ''"
          (click)="saveOrUpdate()"
        >
          {{ data.id ? "Update" : "Add" }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isDataLoaded" class="load-wrap v-center">
    <app-loading [text]="'Loading data'"></app-loading>
  </div>
</div>
